import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/dia-festivo-detalle/';

/**
 * GET Dia Festivo Del Año
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDiasFestivosDelAñoPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dia Festivo Del Año
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDiasFestivosDelAño = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dia Festivo Del Año
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDiaFestivoDelAño = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Dia Festivo Del Año
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDiaFestivoDelAño = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dia Festivo Del Año
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDiaFestivoDelAño = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dia Festivo Del Año
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDiaFestivoDelAño = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Dia Festivo Del Año
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarDiaFestivoDelAño = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
